import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class SidekiqService {
  private url = 'sidekiq';

  constructor(private httpClient: HttpClientService) {}

  clearCounters(): Promise<any> {
    return this.httpClient.get(`${this.url}/reset_counters.json`);
  }

  clearResetQueue(): Promise<any> {
    return this.httpClient.get(`${this.url}/clear_resets.json`);
  }

  createReminderCron(): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, { create_reminder_cron: true });
  }

  destroyCron(cronJobName: string): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, { destroy_cron: cronJobName });
  }

  disableCron(cronJobName: string): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, { disable_cron: cronJobName });
  }

  enableCron(cronJobName: string): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, { enable_cron: cronJobName });
  }

  enqueCron(cronJobName: string): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, { enque_cron: cronJobName });
  }

  killSidekiq(): Promise<any> {
    return this.httpClient.get(`${this.url}/kill_sidekiq.json`);
  }

  sidekiqCronInfo(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { cron_info: true });
  }

  sidekiqInfo(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`);
  }

  startSidekiq(): Promise<any> {
    return this.httpClient.get(`${this.url}/start_sidekiq.json`);
  }
}
